/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SuggestionQuestions = {
    type: 'array',
    contains: {
        type: 'SuggestionQuestion',
    },
};